import { Vue, Component } from "vue-property-decorator";
import { namespace, Getter, Action, Mutation } from "vuex-class";

import { storeModules } from "../../../store";
import { SOCKET_METHOD, SOCKET_RECEIVE_MESSAGE_TYPES } from "../../../common/socket.constants";

const LookupGetter = namespace(storeModules.Lookup, Getter);
const LookupAction = namespace(storeModules.Lookup, Action);
const LookupMutation = namespace(storeModules.Lookup, Mutation);

@Component({
})
export default class LookupDataListener extends Vue {
    @LookupGetter private storedlookupObject;
    @LookupAction private getLookupData: (type: string) => Promise<any>;
    @LookupMutation removeLookupObjectByKey: (key: string) => void;
    private lookupDateChangeListenerHandle(lookupTypes: string[]) {
        lookupTypes.forEach(type => {
            if (this.storedlookupObject[type]) {
                this.removeLookupObjectByKey(type);
                this.getLookupData(type);
            }
        })
    }
    render() {
        return this.$slots.default;
    }
    mounted() {
        this.$socket.onEvent(SOCKET_METHOD.RECEIVE_MESSAGE, ({ name, data }) => {
            console.log(`Socket onEvent: ${SOCKET_METHOD.RECEIVE_MESSAGE} - payload: ${name} - ${data}`);
            if (name === SOCKET_RECEIVE_MESSAGE_TYPES.LOOKUP_DATA) {
                this.lookupDateChangeListenerHandle(data);
            }
        })
    }
}